<!-- <div mat-dialog-content> -->
    <!-- style="min-height: 215px;" style="display: contents;">
-->
<!-- style="padding-left: .5em;" -->
<mat-dialog-content class="mat-typography" >
    <div class="container popup-container" *ngIf="!displayProperties.showLoading">
        <div class="row">
            <div class="col-3" *ngIf="displayProperties.icon !== ''">
                <div class="row">
                    <div class="col">
                        <mat-icon class="popup-icon" [class]="displayProperties.iconClass">{{displayProperties.icon}}</mat-icon>
                    </div>
                </div>
            </div>
            <div class="col">
                <div class="row">
                    <div class="col">
                        <h1 [class]="displayProperties.iconClass">{{data.title}}</h1>
                    </div>
                </div>
                <div class="row">
                    <div class="col">
                        <h3>{{data.subtitle}}</h3>
                    </div>
                </div>
                <!-- <div class="row">
                    <div class="col">
                        <p >{{data.message}}</p>
                    </div>
                </div> -->
            </div>
        </div>
        <div class="row">
            <div class="col">
                <p >{{data.message}}</p>
            </div>
        </div>
        <!-- <div class="row" *ngIf="data.items.length>0">
            <div class="col-12"> -->
            <mat-list style="height: unset;">
                <mat-list-item style="height: unset;" *ngFor="let item of data.items">
                    <mat-icon mat-list-icon class="popup-icon" *ngIf="displayProperties.icon !== ''" [class]="displayProperties.iconClass" style="font-size: 1.5em;">{{displayProperties.icon}}</mat-icon>
                    <!-- <div mat-line>{{item}}</div> -->
                    <!-- <span>{{item}}</span> -->
                    <span [innerHTML]="item"></span>
                </mat-list-item>
            </mat-list>
            <!-- </div> -->
        <!-- </div> -->
    </div>
    <div class="container popup-container" style="text-align: center;" *ngIf="displayProperties.showLoading">
        <div class="row">
            <div class="col-12">
                <h1 >{{data.title}}</h1>
            </div>
        </div>
        <div class="row" *ngIf="displayProperties.showConfirm">
            <div class="col-12">
                <mat-icon class="popup-icon" [class]="displayProperties.iconClass" style="min-width: 100%;">{{displayProperties.icon}}</mat-icon>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <mat-progress-bar *ngIf="displayProperties.showConfirm" style="padding-bottom: 8px; margin-bottom: 8px;" mode="indeterminate"></mat-progress-bar>
                <img *ngIf="!displayProperties.showConfirm" src="../../../assets/images/loadingSpinner.gif" alt="Loading Spinner" style="width:100px;height:100px;">
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <p >{{data.message}}</p>
            </div>
        </div>
        <div class="row" *ngIf="displayProperties.showConfirm">
            <div class="col-12">
                <p [class]="displayProperties.iconClass">It seems the process is taking longer than expected.</p>
            </div>
        </div>
    </div>
</mat-dialog-content>
<mat-dialog-content>
    <div class="container popup-container"  *ngIf="!displayProperties.showLoading">
        <mat-divider></mat-divider>
        <br>
        <div class="row" *ngIf="displayProperties.showConfirm">
            <div class="col-6" [class]="displayProperties.iconClass" >
                <button mat-raised-button color="primary"(click)="onConfirm()" class="fill-w">{{confirmButtonTitle}}</button>
            </div>
            <div class="col-6">
                <button mat-stroked-button  (click)="onDismiss()" class="fill-w">{{dismissButtonTitle}}</button>
            </div>
        </div>
        <div class="row" *ngIf="!displayProperties.showConfirm">
            <div class="col" [class]="displayProperties.iconClass">
                <button mat-raised-button color="primary" class="fill-w"(click)="onConfirm()">Ok</button>
            </div>
        </div>
    </div>
    <div class="container popup-container"  *ngIf="displayProperties.showLoading">
        <mat-divider *ngIf="displayProperties.showConfirm"></mat-divider>
        <br *ngIf="displayProperties.showConfirm">
        <div class="row" *ngIf="displayProperties.showConfirm">
            <div class="col" [class]="displayProperties.iconClass">
                <button mat-raised-button color="primary" class="fill-w"(click)="onConfirm()">Cancel</button>
            </div>
        </div>
    </div>
</mat-dialog-content>


